import { render, staticRenderFns } from "./PastBookings.vue?vue&type=template&id=fc148f62&scoped=true"
import script from "./PastBookings.vue?vue&type=script&lang=js"
export * from "./PastBookings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc148f62",
  null
  
)

export default component.exports